"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimateBreakdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const ArrowBackIos_1 = __importDefault(require("@mui/icons-material/ArrowBackIos"));
const ArrowForwardIosOutlined_1 = __importDefault(require("@mui/icons-material/ArrowForwardIosOutlined"));
const Chat_1 = __importDefault(require("@mui/icons-material/Chat"));
const useCalcResponse_1 = require("../../hooks/useCalcResponse");
const TextHelper_1 = require("../../services/TextHelper");
const FeesableDialog_1 = __importDefault(require("../FeesableDialog/FeesableDialog"));
const EstimateCallout_1 = require("../parts/EstimateCallout");
const InfoPopup_1 = require("../parts/InfoPopup");
const EstimateBreakdownChild_1 = require("./EstimateBreakdownChild");
const useInfoCloseFnRef_1 = require("../../hooks/useInfoCloseFnRef");
const useSetInfoCloseFnRef_1 = require("../../hooks/useSetInfoCloseFnRef");
const StyledContentWrapper = (0, styles_1.styled)(material_1.DialogContent)(({ theme }) => ({
    fontSize: '14px',
    '& .col-left': {
        width: '100%',
    },
    '& .col-right1': {
        color: theme.palette.custom.primaryMedium,
        whiteSpace: 'nowrap',
    },
    '& .col-right2': {
        width: '112px',
        textAlign: 'right',
        whiteSpace: 'nowrap',
    },
    '& .colRight2>p': {
        textAlign: 'right!important',
        whiteSpace: 'nowrap',
    },
    '& .col-header-right2': {
        textTransform: 'uppercase',
        fontSize: '0.9em',
        color: theme.palette.custom.textMedium,
        marginLeft: 10,
    },
    '& .col-header-right1': {
        textTransform: 'uppercase',
        fontSize: '0.9em',
        color: theme.palette.custom.textLight,
    },
    '& .notesWrapper': {
        marginTop: theme.spacing(2),
        color: theme.palette.custom.textLight,
        '& span': {
            fontSize: '11px',
            lineHeight: 1.5,
        },
    },
    '& .notes': {
        marginTop: '4px',
        marginLeft: 0,
        paddingLeft: 0,
        listStyle: 'none',
        '& li': {
            paddingBottom: '8px',
        },
    },
    '& .noteRef': {
        width: '10px',
        display: 'inline-block',
        fontWeight: 'bold',
    },
}));
const StyledColumnHeader = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'right',
    paddingTop: theme.spacing(1),
    paddingBottom: 0,
    marginBottom: '-14px',
    color: theme.palette.custom.textMedium,
}));
const StyledTotalWrapper = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: theme.palette.primary.main,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.palette.custom.primary,
    '& .colRight2>p': {
        textAlign: 'right!important',
    },
}));
const StyledModifiedTotalWrapper = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    borderTop: '1px solid',
    borderBottom: '1px solid',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& .totalAdditionalItemsHeader': {
        display: 'flex',
        color: theme.palette.custom.textMedium,
    },
}));
const StyledBreakdownItem = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 0,
    color: theme.palette.custom.textMedium,
    '& .breakdown-item-title': {
        color: theme.palette.custom.textLight,
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        minHeight: '28px',
    },
    '& .breakdownItemValue': {
        color: theme.palette.custom.textMedium,
        fontSize: '13px',
    },
}));
const StyledAdditionalItems = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3),
    '& .additionalItemsHeader': {
        display: 'flex',
        color: theme.palette.custom.textMedium,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    '& .refs': {
        fontSize: '0.8em',
        paddingLeft: '5px',
        marginTop: '-10px',
    },
}));
const StyledFeedbackButton = (0, styles_1.styled)(material_1.Button)(() => ({
    textTransform: 'uppercase',
    minWidth: '180px',
    marginLeft: '8px',
}));
const StyledAlertMessage = (0, styles_1.styled)('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
}));
const StyledFeedbackSection = (0, styles_1.styled)('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.custom.surfaceMedium,
    padding: theme.spacing(2),
    width: '100%',
}));
const StyledInstalmentOptions = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.custom.surfaceMedium,
    '& .additionalItemsHeader': {
        display: 'flex',
        color: theme.palette.custom.textMedium,
        marginBottom: theme.spacing(1),
    },
    '& .refs': {
        fontSize: '0.8em',
        paddingLeft: '5px',
        marginTop: '-10px',
    },
}));
const StyledNavigationIconLeft = (0, styles_1.styled)('div')(({ theme }) => ({
    backgroundColor: '#E1E1E4',
    padding: theme.spacing(3),
    borderRadius: '50%',
    display: 'flex',
    cursor: 'pointer',
    position: 'fixed',
    left: '25%',
    [theme.breakpoints.down('xl')]: {
        left: '20%',
    },
    [theme.breakpoints.down('lg')]: {
        left: '10%',
    },
    [theme.breakpoints.down('md')]: {
        left: '5%',
    },
}));
const StyledNavigationIconRight = (0, styles_1.styled)('div')(({ theme }) => ({
    backgroundColor: '#E1E1E4',
    padding: theme.spacing(3),
    borderRadius: '50%',
    display: 'flex',
    cursor: 'pointer',
    position: 'fixed',
    right: '25%',
    [theme.breakpoints.down('xl')]: {
        right: '20%',
    },
    [theme.breakpoints.down('lg')]: {
        right: '10%',
    },
    [theme.breakpoints.down('md')]: {
        right: '5%',
    },
}));
const StyledBoxContainer = (0, styles_1.styled)(material_1.Box)(() => ({
    display: 'flex',
    alignItems: 'center',
}));
const EstimateBreakdown = ({ yearData, isOpen, onCloseBreakdown, config, periods, isNextEnabled, isPrevEnabled, onNext, onPrev, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const calcResponse = (0, useCalcResponse_1.useCalcResponse)();
    const infoCloseFnRef = (0, useInfoCloseFnRef_1.useInfoCloseFnRef)();
    const setInfoCloseFnRef = (0, useSetInfoCloseFnRef_1.useSetInfoCloseFnRef)();
    //Hardcoded to 825px because of the custom button layout
    const isSmallScreen = (0, material_1.useMediaQuery)('(max-width:825px)');
    (0, react_1.useEffect)(() => {
        window.parent.postMessage({ scroll: 'SCROLL_TO_TOP' }, '*');
    }, []);
    const onCloseModal = () => {
        onCloseBreakdown();
        infoCloseFnRef && infoCloseFnRef();
    };
    const onClickFeedback = () => {
        var _a, _b;
        try {
            window.open(`${(_a = config.feedback) === null || _a === void 0 ? void 0 : _a.cta.link}?schoolId=${config.schoolId}&submissionId=${(_b = calcResponse.data) === null || _b === void 0 ? void 0 : _b.submissionId}`, '_blank');
        }
        catch (e) {
            console.error(e);
        }
    };
    if (!yearData || !periods.year)
        return null;
    const buildFamilyLineItems = (location, includeTitle = false) => {
        var _a, _b;
        if (yearData.lines[location].length === 0)
            return null;
        const isInTotal = location === 'inTotal';
        const isAfterTotal = location === 'afterTotal';
        const hasMoreThanOneLineItem = Array.from(yearData.lines[location]).length > 1;
        const getSubTotal = () => yearData.lines[location].reduce((acc, item) => {
            return acc + (item.amt || 0);
        }, 0);
        const subTotal = getSubTotal();
        return ((0, jsx_runtime_1.jsxs)(StyledAdditionalItems, { children: [includeTitle && ((0, jsx_runtime_1.jsxs)("div", { className: "additionalItemsHeader", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-left", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: (0, jsx_runtime_1.jsxs)("strong", { children: ["Additional Items for ", yearData.year] }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-right2 col-header-right2", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", children: (0, jsx_runtime_1.jsx)("strong", { children: "Once Off" }) }) })] })), yearData.lines[location].map((line) => {
                    var _a;
                    return ((0, jsx_runtime_1.jsxs)(StyledBreakdownItem, { children: [(0, jsx_runtime_1.jsxs)(StyledBoxContainer, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: 'body2', className: "breakdown-item-title", children: [line.title, line.refs && line.refs.length > 0 && ((0, jsx_runtime_1.jsxs)("sup", { className: "refs", children: ["[", line.refs.join(','), "]"] }))] }), line.info && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { zIndex: 9999 }, children: (0, jsx_runtime_1.jsx)(InfoPopup_1.InfoPopup, { popId: line.key, infos: [line.info], getCloseInfoRef: (cb) => setInfoCloseFnRef(cb) }) }))] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: 'body2', className: "breakdown-item-value", children: (0, TextHelper_1.formatNumberCurrency)(line.amt, (_a = rounding === null || rounding === void 0 ? void 0 : rounding.yearTotal) === null || _a === void 0 ? void 0 : _a.displayDecimals, config.terms) })] }, line.key));
                }), isInTotal && hasMoreThanOneLineItem && subTotal > 0 && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { borderBottom: '1px solid #dcdcdc' }, children: (0, jsx_runtime_1.jsxs)(EstimateBreakdownChild_1.StyledChildRow, { className: "childRowTotal", children: [(0, jsx_runtime_1.jsx)("div", { className: "colLeft", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: 'body2', className: "childRowTotalTitle", children: (0, jsx_runtime_1.jsx)("strong", { children: "Total Additional Items" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "colRight2", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: 'body2', className: "childRowTotalValue", children: (0, jsx_runtime_1.jsx)("strong", { children: (0, TextHelper_1.formatNumberCurrency)(subTotal, (_a = rounding === null || rounding === void 0 ? void 0 : rounding.subTotal) === null || _a === void 0 ? void 0 : _a.displayDecimals, config.terms) }) }) })] }, "inTotalOtherFees") })), isAfterTotal && hasMoreThanOneLineItem && subTotal > 0 && ((0, jsx_runtime_1.jsx)(StyledModifiedTotalWrapper, { children: (0, jsx_runtime_1.jsxs)("div", { className: "totalAdditionalItemsHeader", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-left", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: (0, jsx_runtime_1.jsx)("strong", { children: "Total Additional Items" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-right2 col-header-right2", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { fontWeight: 300, children: (0, jsx_runtime_1.jsx)("strong", { style: { fontSize: 12 }, children: (0, TextHelper_1.formatNumberCurrency)(subTotal, (_b = rounding === null || rounding === void 0 ? void 0 : rounding.subTotal) === null || _b === void 0 ? void 0 : _b.displayDecimals, config.terms) }) }) })] }) }))] }, 'additionalItems'));
    };
    const getCallout = () => {
        if (!yearData.flags.indicative)
            return null;
        return ((0, jsx_runtime_1.jsx)(EstimateCallout_1.EstimateCallout, { text: config.terms.futureYears, info: config.terms.futureYearsDisclaimer, icon: "warning" }));
    };
    const rounding = config.features.move.setup.rounding;
    const downloadButtonFilename = ((_b = (_a = config.features.download) === null || _a === void 0 ? void 0 : _a.breakdown) === null || _b === void 0 ? void 0 : _b.enabled)
        ? `${config.features.download.breakdown.filePrefix}${yearData.year} Fees - ${(_c = calcResponse === null || calcResponse === void 0 ? void 0 : calcResponse.data) === null || _c === void 0 ? void 0 : _c.submissionId}`
        : '';
    const yearIndex = calcResponse.data.years.findIndex((year) => year.year === yearData.year);
    // TODO temp fix, needs to be implemented properly
    const optionalFees = (_f = (_e = (_d = calcResponse.data.years[yearIndex || 0]) === null || _d === void 0 ? void 0 : _d.family) === null || _e === void 0 ? void 0 : _e.fees) === null || _f === void 0 ? void 0 : _f.optionalFees;
    const optionalFeesTotal = optionalFees && Array.isArray(optionalFees)
        ? (_j = (_h = (_g = calcResponse.data.years[yearIndex || 0]) === null || _g === void 0 ? void 0 : _g.family) === null || _h === void 0 ? void 0 : _h.fees) === null || _j === void 0 ? void 0 : _j.optionalFees.find((item) => item.type === 'total')
        : null;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(FeesableDialog_1.default, { open: isOpen, onCloseModal: onCloseModal, modalTitle: `${yearData.year} Fee Breakdown`, size: "sm", onNext: isNextEnabled ? onNext : undefined, onPrev: isPrevEnabled ? onPrev : undefined, isSmallScreen: isSmallScreen, downloadButtonFilename: downloadButtonFilename, children: [getCallout(), (0, jsx_runtime_1.jsxs)(StyledContentWrapper, { children: [(0, jsx_runtime_1.jsxs)(StyledColumnHeader, { children: [(0, jsx_runtime_1.jsx)("div", { className: "col-left", children: "\u00A0" }), periods.nonYear && ((0, jsx_runtime_1.jsx)("div", { className: "col-right1 col-header-right1", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", children: (0, jsx_runtime_1.jsx)("strong", { children: periods.nonYear.title }) }) })), (0, jsx_runtime_1.jsx)("div", { className: "col-right2 col-header-right2", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", children: (0, jsx_runtime_1.jsx)("strong", { children: periods.year.title }) }) })] }), yearData.students.map((student) => ((0, jsx_runtime_1.jsx)(EstimateBreakdownChild_1.EstimateBreakdownChild, { student: student, periods: periods, config: config }, student.id))), buildFamilyLineItems('inTotal'), (0, jsx_runtime_1.jsxs)(StyledTotalWrapper, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { className: "col-left", children: ["Total ", yearData.year, " Fee Estimate"] }), periods.nonYear && ((0, jsx_runtime_1.jsx)("div", { className: "col-right1", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: (0, jsx_runtime_1.jsx)("strong", { children: (0, TextHelper_1.formatNumberCurrency)(yearData.periods[periods.nonYear.key], 'never', config.terms) }) }) })), (0, jsx_runtime_1.jsx)("div", { className: "col-right2", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: (0, jsx_runtime_1.jsx)("strong", { children: (0, TextHelper_1.formatNumberCurrency)(yearData.periods[periods.year.key], (_k = rounding === null || rounding === void 0 ? void 0 : rounding.yearTotal) === null || _k === void 0 ? void 0 : _k.displayDecimals, config.terms) }) }) })] }), optionalFeesTotal && ((0, jsx_runtime_1.jsx)(material_1.Alert, { icon: false, severity: "info", sx: (theme) => ({
                                '& .MuiAlert-message': {
                                    width: '100%',
                                    p: 0,
                                },
                                backgroundColor: theme.palette.custom.surfaceMedium,
                            }), children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "body1", sx: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    width: '100%',
                                    color: 'primary.main',
                                }, children: [(optionalFeesTotal === null || optionalFeesTotal === void 0 ? void 0 : optionalFeesTotal.effectBy) === '%' ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Total if paid upfront (", optionalFeesTotal === null || optionalFeesTotal === void 0 ? void 0 : optionalFeesTotal.effect, "%)"] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Total if paid upfront (", (0, TextHelper_1.formatNumberCurrency)(Math.abs((_l = optionalFeesTotal === null || optionalFeesTotal === void 0 ? void 0 : optionalFeesTotal.amount) !== null && _l !== void 0 ? _l : 0), 'ifPresent', config === null || config === void 0 ? void 0 : config.terms), ")"] })), (0, jsx_runtime_1.jsx)("strong", { children: (0, TextHelper_1.formatNumberCurrency)(yearData.periods[periods.year.key] -
                                            Math.abs((_m = optionalFeesTotal === null || optionalFeesTotal === void 0 ? void 0 : optionalFeesTotal.amount) !== null && _m !== void 0 ? _m : 0), (_o = rounding === null || rounding === void 0 ? void 0 : rounding.yearTotal) === null || _o === void 0 ? void 0 : _o.displayDecimals, config.terms) })] }) })), buildFamilyLineItems('afterTotal', true), ((_p = yearData === null || yearData === void 0 ? void 0 : yearData.instalmentOptions) === null || _p === void 0 ? void 0 : _p.length) > 0 && ((0, jsx_runtime_1.jsxs)(StyledInstalmentOptions, { children: [(0, jsx_runtime_1.jsx)("div", { className: "additionalItemsHeader", children: (0, jsx_runtime_1.jsx)("div", { className: "col-left", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: (0, jsx_runtime_1.jsx)("strong", { children: "Instalment Options" }) }) }) }), (_q = yearData === null || yearData === void 0 ? void 0 : yearData.instalmentOptions) === null || _q === void 0 ? void 0 : _q.map((item, index) => {
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                                    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(StyledBreakdownItem, { children: [(0, jsx_runtime_1.jsxs)(StyledBoxContainer, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: 'body2', className: "breakdown-item-title", children: item.label }), item.info && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { zIndex: 9999 }, children: (0, jsx_runtime_1.jsx)(InfoPopup_1.InfoPopup, { popId: item.key, infos: [item.info], getCloseInfoRef: (cb) => setInfoCloseFnRef(cb) }) }))] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: 'body2', className: "breakdown-item-value", children: (0, TextHelper_1.formatNumberCurrency)((0, TextHelper_1.roundNumber)(item.amount, (_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.fees) === null || _a === void 0 ? void 0 : _a.instalmentOptions) === null || _b === void 0 ? void 0 : _b.rounding) === null || _c === void 0 ? void 0 : _c.type, (_f = (_e = (_d = config === null || config === void 0 ? void 0 : config.fees) === null || _d === void 0 ? void 0 : _d.instalmentOptions) === null || _e === void 0 ? void 0 : _e.rounding) === null || _f === void 0 ? void 0 : _f.precision), (_j = (_h = (_g = config.fees) === null || _g === void 0 ? void 0 : _g.instalmentOptions) === null || _h === void 0 ? void 0 : _h.rounding) === null || _j === void 0 ? void 0 : _j.displayDecimals, config.terms) })] }, index) }, item.key));
                                })] })), (config === null || config === void 0 ? void 0 : config.feedback) && ((0, jsx_runtime_1.jsx)(StyledFeedbackSection, { children: (0, jsx_runtime_1.jsxs)(StyledAlertMessage, { children: [(0, jsx_runtime_1.jsx)("strong", { children: config.feedback.description }), (0, jsx_runtime_1.jsx)(StyledFeedbackButton, { variant: "contained", startIcon: (0, jsx_runtime_1.jsx)(Chat_1.default, {}), onClick: onClickFeedback, children: (_r = config.feedback.cta) === null || _r === void 0 ? void 0 : _r.label })] }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, { className: "notesWrapper", children: [yearData.notes.filter((n) => n.amt && n.amt > 0).length > 0 && ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", children: (0, jsx_runtime_1.jsx)("strong", { children: "Other Fees & Levies" }) })), (0, jsx_runtime_1.jsx)("ul", { className: "notes", children: yearData.notes.map((n) => {
                                        let text = n.title || n.note || '';
                                        if (n.amt)
                                            text = `${text} <strong>${(0, TextHelper_1.formatNumberCurrency)(n.amt, 'never', config.terms)}</strong>`;
                                        if (n.ref)
                                            text = `<span class="noteRef">${n.ref}</span> ${text}`;
                                        return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: text } }) }) }, n.ruleId));
                                    }) })] }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "caption", sx: { color: 'custom.textLight' }, children: [config.name, " | \u00A9 ", new Date().getFullYear(), " Feesable"] }), !isSmallScreen && isOpen && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { position: 'fixed', top: '50%', right: '50%' }, children: [(0, jsx_runtime_1.jsx)(StyledNavigationIconLeft, { onClick: onPrev, sx: { visibility: isPrevEnabled ? 'visible' : 'hidden' }, children: (0, jsx_runtime_1.jsx)(ArrowBackIos_1.default, { sx: { color: '#86868B', fontSize: 'inherit' } }) }), (0, jsx_runtime_1.jsx)(StyledNavigationIconRight, { onClick: onNext, sx: { visibility: isNextEnabled ? 'visible' : 'hidden' }, children: (0, jsx_runtime_1.jsx)(ArrowForwardIosOutlined_1.default, { sx: { color: '#86868B', fontSize: 'inherit' } }) })] }) }))] })] }) }));
};
exports.EstimateBreakdown = EstimateBreakdown;
